

import React, { useState, useEffect } from "react";
import { Row, Col, Form, Modal, Button } from "react-bootstrap";
import axios from "axios";
import config from "../config/config";
import { ToastContainer, toast } from "react-toastify";
import LoadingSpinner from "../Components/LoadingSpinner";
import moment from "moment";
import { formatTime, getInstructorList } from "../Utils/utils";
import DatePicker from "react-datepicker";
// import moment from "moment-timezone";


const EditSou = (props) => {
  const { souModal, setSouModal, setReloadData, souData } = props;
  const [courseNumber, setCourseNumber] = useState('')
  const [startDate, setStartDate] = useState(new Date())
  const [phoneNumber, setPhoneNumber] = useState('')
  const [homeEmail, setHomeEmail] = useState('')
  const [workEmail, setWorkEmail] = useState('')
  const [dataRow, setDataRow] = useState({})
  const [isLoading, setIsLoading] = useState(false);
  const [studentId, setStudentId] = useState('');
  const [instList, setInstList] = useState([]);
  const [instructor, setInstructor] = useState('');
  const [instructorName, setInstructorName] = useState('');

  const handleCloseModal = () => {
    setSouModal(false)
    setDataRow([])
  }

  const getInstructor = async () => {
    var temp = []
    var res = await getInstructorList(souData?.language?.id)
    res.map((e) => {
      temp.push({
        value: e.id, label: e.first_name + ' ' + e.last_name, language_id: e.select_language
      })
    })
    setInstList(temp)
  }

  useEffect(() => {
    getInstructor()
  }, [souData?.language?.id])

  const saveDateChanges = async () => {
    dataRow.COURSE_NUMBER = courseNumber
    dataRow.new_start_date = moment(startDate).format("YYYY-MM-DD")
    dataRow.PHONE = phoneNumber
    dataRow.HOME_EMAIL = homeEmail
    dataRow.WORK_EMAIL = workEmail
    dataRow.instructor_id = instructor
    dataRow.instructor_name = instructorName
    updateData()
  }
  const updateData = async () => {
    setIsLoading(true)
    const request = {
      'LD_SID': studentId,
      'COURSE_NUMBER': courseNumber,
      'new_start_date': moment(startDate).format("YYYY-MM-DD"),
      'PHONE': phoneNumber,
      'HOME_EMAIL': homeEmail,
      'WORK_EMAIL': workEmail,
      'INSTRUCTOR_ID': instructor,
    }
    let path = config.siteUrl;
    try {
      const res = await axios.post(path + '/classes/update-raw-data-sou', request, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',

        }
      })
      if (res.data.status == 200) {
        setIsLoading(false)
        setSouModal(false)
        setDataRow(res.data.data)
        toast.success(res.data.message)

      } else {
        toast.error(res?.data?.message || "Something went wrong");
      }
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Unable to update. Please try again.";

      toast.error(message);
    } finally {
      setIsLoading(false);
    }
  }


  useEffect(() => {
    if (souData != undefined) {
      setDataRow(souData)
      setStudentId(souData?.LD_SID)
      setCourseNumber(souData.serialized_course_number)
      setStartDate(moment(souData.new_start_date).toDate());
      setPhoneNumber(souData.PHONE)
      setHomeEmail(souData.HOME_EMAIL)
      setWorkEmail(souData.WORK_EMAIL)
      setInstructor(souData.instructor_id)

      //console.log(souData)
    }
  }, [souData])



  return (
    <>
      <div>
        <ToastContainer
          position="top-center"
        />
        <LoadingSpinner isLoading={isLoading} />
        <Modal size="md" show={souModal} onHide={handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title>Edit</Modal.Title>
          </Modal.Header>
          <Modal.Body>

            <Form>
              <Row className="mb-3">
                <Col sm={4}>
                  <Form.Label>Course Number</Form.Label>
                </Col>
                <Col sm={8}>
                  <Form.Control
                    value={courseNumber}
                    type="text"
                    onChange={(e) => setCourseNumber(e.target.value)}
                  />
                </Col>
              </Row>

              <Row className="mb-3">
                <Col sm={4}>
                  <Form.Label>Instructor</Form.Label>
                </Col>
                <Col sm={8}>
                  <Form.Select
                    value={instructor}
                    onChange={
                      (e) => {
                        const selectedOption = e.target.options[e.target.selectedIndex];
                        setInstructor(e.target.value);
                        setInstructorName(selectedOption.text);
                      }
                    }
                  >
                    {instList.map((inst) => (
                      <option key={inst.label} value={inst.value}>
                        {inst.label}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col sm={4}>
                  <Form.Label>Phone Number</Form.Label>
                </Col>
                <Col sm={8}>
                  <Form.Control
                    value={phoneNumber}
                    type="number"
                    onChange={(e) => setPhoneNumber(e.target.value)}
                  />
                </Col>
              </Row>

              <Row className="mb-3">
                <Col sm={4}>
                  <Form.Label>Home Email</Form.Label>
                </Col>
                <Col sm={8}>
                  <Form.Control
                    value={homeEmail}
                    type="text"
                    onChange={(e) => setHomeEmail(e.target.value)}
                  />
                </Col>
              </Row>

              <Row className="mb-3">
                <Col sm={4}>
                  <Form.Label>Work Email</Form.Label>
                </Col>
                <Col sm={8}>
                  <Form.Control
                    value={workEmail}
                    type="text"
                    onChange={(e) => setWorkEmail(e.target.value)}
                  />
                </Col>
              </Row>

              <Row className="mb-3">
                <Col sm={4}>
                  <Form.Label>Start Date</Form.Label>
                </Col>
                <Col sm={8}>
                  <DatePicker
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                    dateFormat="MM/dd/yyyy"
                    className="inputt"
                  />
                </Col>
              </Row>

            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Close
            </Button>
            <Button variant="primary" onClick={() => {
              saveDateChanges()
            }}>
              Save Changes
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  )
}
export default EditSou



